module.exports = __webpack_public_path__ + "tr.044b3721eeaf7c0012bc.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tr.svg
// module chunks = styles